<template>
    <login-1 v-if="client==1"></login-1>
    <Login_sbm v-if="client==2 || client==null" ></Login_sbm>
    <login-2 v-if="client==3"></login-2>
</template>
<script>
import Login_sbm from './Login_sbm.vue'
import Login1  from './Login1.vue'
import Login2  from './Login2.vue'
export default {
    data() {
        return {
            client:"",
        }
    },
    created(){
            let urlParams = new URLSearchParams(window.location.search);
    // console.log(urlParams.has('yourParam')); // true
    // console.log(urlParams.get('yourParam')); // "MyParam"
    // alert(urlParams.get('client'))
    this.client=urlParams.get('client')

    },
    components:{
        Login1,
        Login_sbm,
        Login2
    }
}
</script>
